/* ComBank compliance: Terms & Conditions checkout gate.
   Loaded with defer from layout/theme.liquid so the gate works for every
   cart type.
   - Checkout buttons ship with the `disabled` attribute in markup and are
     only enabled once a terms checkbox is ticked.
   - All terms checkboxes are kept in sync (drawer + /cart page).
   - Express/dynamic checkout buttons are locked with `inert` so they are
     unreachable by keyboard and pointer until terms are accepted.

   UX AUDIT FIX, July 2026: the disabled Checkout button previously gave no
   reason for being inactive. Customers who missed the checkbox read it as a
   broken site. This now adds an explanatory hint under the button and sets
   aria-disabled so assistive technology announces the state correctly. */
(function () {
  var HINT_TEXT = 'Tick the box above to continue to checkout.';
  var HINT_CLASS = 'er-checkout-hint';

  function hintFor(btn) {
    if (!btn || !btn.parentNode) return null;
    var existing = btn.parentNode.querySelector('.' + HINT_CLASS);
    if (existing) return existing;
    var p = document.createElement('p');
    p.className = HINT_CLASS;
    p.textContent = HINT_TEXT;
    p.setAttribute('aria-live', 'polite');
    if (btn.id) p.id = btn.id + '-terms-hint';
    btn.parentNode.insertBefore(p, btn.nextSibling);
    if (p.id) {
      var described = btn.getAttribute('aria-describedby');
      btn.setAttribute('aria-describedby', described ? described + ' ' + p.id : p.id);
    }
    return p;
  }

  function setTermsState(accepted) {
    document.querySelectorAll('.js-terms-agree').forEach(function (cb) {
      cb.checked = accepted;
      var btn = document.getElementById(cb.dataset.checkout);
      if (!btn) return;
      btn.disabled = !accepted;
      btn.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      var hint = hintFor(btn);
      if (hint) hint.hidden = accepted;
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (dyn) {
      dyn.classList.toggle('is-terms-locked', !accepted);
      if (accepted) {
        dyn.removeAttribute('inert');
      } else {
        dyn.setAttribute('inert', '');
      }
    });
  }

  function syncTermsState() {
    var boxes = document.querySelectorAll('.js-terms-agree');
    if (!boxes.length) return;
    var accepted = Array.prototype.some.call(boxes, function (cb) { return cb.checked; });
    setTermsState(accepted);
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (cb && cb.classList && cb.classList.contains('js-terms-agree')) {
      setTermsState(cb.checked);
    }
  });

  /* Clicking a disabled button fires no event, so a customer who does not
     notice the checkbox gets no feedback at all. Catching the click on the
     wrapper lets us draw attention to the control that is blocking them. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="checkout"]') : null;
    if (!btn || !btn.disabled) return;
    var row = document.querySelector('.cart__terms');
    if (!row) return;
    row.classList.add('er-terms-flash');
    var box = row.querySelector('.js-terms-agree');
    if (box && box.focus) box.focus();
    setTimeout(function () { row.classList.remove('er-terms-flash'); }, 1200);
  }, true);

  // Initial sync (also covers browsers restoring a previously ticked box).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTermsState);
  } else {
    syncTermsState();
  }
  // Re-sync when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncTermsState();
  });
})();
